import React from 'react';
import styled from 'styled-components';
import { Input, Button, COLOR_SYSTEM, Text } from 'components/atoms';
import Dropdown, { DropdownMenuItem } from 'components/molecules/Dropdown';
import { GroundTruthFilters as Filters } from 'services/api/aiReviewTest/groundTruthApi';
import { PromptType, PROMPT_TYPE_KOREAN_NAMES } from 'common/models/types';

interface GroundTruthFiltersProps {
  filters: Filters;
  onFiltersChange: (filters: Filters) => void;
  onReset: () => void;
}

const GroundTruthFilters: React.FC<GroundTruthFiltersProps> = ({
  filters,
  onFiltersChange,
  onReset,
}) => {
  const [showPromptDropdown, setShowPromptDropdown] = React.useState(false);
  const promptTypeOptions = [
    { value: '', label: '전체' },
    { value: PromptType.MEDICATION_COUNSELING, label: PROMPT_TYPE_KOREAN_NAMES[PromptType.MEDICATION_COUNSELING] },
    { value: PromptType.CMM_2, label: PROMPT_TYPE_KOREAN_NAMES[PromptType.CMM_2] },
    { value: PromptType.LCMM, label: PROMPT_TYPE_KOREAN_NAMES[PromptType.LCMM] },
    { value: PromptType.FREE_QUESTION, label: PROMPT_TYPE_KOREAN_NAMES[PromptType.FREE_QUESTION] },
  ];

  const handlePromptTypeChange = (value: string) => {
    onFiltersChange({
      ...filters,
      promptType: value as PromptType || undefined,
    });
  };

  const handlePatientIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    onFiltersChange({
      ...filters,
      patientId: value ? parseInt(value, 10) : undefined,
    });
  };

  return (
    <FilterSection>
    <FilterRow>
      <FilterGroup>
        <FilterLabel>프롬프트 타입</FilterLabel>
        <Dropdown
          defaultValue="프롬프트 타입"
          selected={promptTypeOptions.find(opt => opt.value === filters.promptType)?.label || '전체'}
          size="Medium"
          active={showPromptDropdown}
          onClick={() => setShowPromptDropdown(!showPromptDropdown)}
        >
          {promptTypeOptions.map((option) => (
            <DropdownMenuItem
              key={option.value}
              onClick={() => {
                handlePromptTypeChange(option.value);
                setShowPromptDropdown(false);
              }}
              isSelected={filters.promptType === option.value}
            >
              {option.label}
            </DropdownMenuItem>
          ))}
        </Dropdown>
      </FilterGroup>
      
      <FilterGroup>
        <FilterLabel>환자 ID</FilterLabel>
        <Input
          type="number"
          placeholder="환자 ID 입력"
          value={filters.patientId?.toString() || ''}
          onChange={handlePatientIdChange}
        />
      </FilterGroup>

      <Button 
        size="Small" 
        type="Text" 
        variant="Ghost" 
        color="Secondary" 
        onClick={onReset}
      >
        필터 초기화
      </Button>
    </FilterRow>
    </FilterSection>
  );
};

const FilterSection = styled.div`
  margin-bottom: 24px;
  padding: 20px;
  background: #f9fafb;
  border-radius: 8px;
  width: 100%;
`;

const FilterRow = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

const FilterGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const FilterLabel = styled(Text)`
  font-size: 14px;
  font-weight: 500;
  color: #4b5563;
  min-width: 100px;
`;

export default GroundTruthFilters;